import { useCallback, useMemo } from 'react'
import { useCookies } from 'react-cookie'

export function useGetCookieValue (key, cookieName = window.env.COOKIE_NAME) {
    const [cookies] = useCookies([cookieName]);
    return useMemo(() => {
        const cookie = cookies[cookieName];
        return (cookie&&cookie[key]&&cookie[key]!=="undefined")?cookie[key]:"";
    }, [cookies, key, cookieName])
}

export function useSetCookie(cookieName = window.env.COOKIE_NAME) {
    const [,setCookies] = useCookies([cookieName]);
    return useCallback((newValue, options) =>{
        setCookies(cookieName, newValue, options);
    },[setCookies, cookieName]);
}

export function useRemoveCookie(cookieName = window.env.COOKIE_NAME) {
    const [,,removeCookies] = useCookies([cookieName]);
    return useCallback(() => {
        removeCookies(cookieName);
    }, [removeCookies, cookieName])
}
   





